import hashes from './hashes'
import { ProfileType } from './types/api'

export function getStoredValue(key: string, defaultValue?: any, session = false) {
  try {
    const item = (session ? window.sessionStorage : window.localStorage).getItem(key)
    return item != null ? JSON.parse(item) : typeof defaultValue === 'function' ? defaultValue() : defaultValue
  } catch (error) {
    console.error(error)
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue
  }
}

export function removedStoredValue(key: string, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).removeItem(key)
  } catch (error) {
    console.error(error)
  }
}

export function setStoredValue(key: string, value: any, session = false) {
  try {
    ;(session ? window.sessionStorage : window.localStorage).setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(error)
  }
}

export function getCookies() {
  const result: { [key: string]: string } = {}
  for (const cookie of document.cookie.split(';')) {
    const parts = cookie.split('=')
    if (parts.length === 2) {
      result[parts[0].trim()] = decodeURIComponent(parts[1].trim())
    }
  }
  return result
}

/* CONFIGURATION */

export const Game = 'poe'

export const VerifiedUserLevel = 2
export const BuildInfoLevel = 2
export const EmbedLevel = 3
export const AdminLevel = 7

export const isDev = typeof process !== 'undefined' && process.env.NODE_ENV === 'development'
//const isTest = !isDev && process.env.PUBLIC_URL.includes('laplanner-test');

export const Locale = 'English'

export const LocalUniques = false
export const UniqueProfile = '2f01062w'
export const CraftingProfile = 'al0106l2'
export const BuildListProfile = 'gg0106jh'

export const FrontendPath = isDev ? 'http://localhost:8788' : 'https://maxroll.gg'
export const BaseAssetPath = 'https://assets-ng.maxroll.gg'
export const assets_path = 'https://assets-ng.maxroll.gg/poeplanner'

export function getProfilePath(id: string, plannerType?: ProfileType) {
  switch (plannerType) {
    case 'atlas-tree':
      return `/poe/poe-atlas-tree/${id}`
    case 'passive-tree':
      return `/poe/poe-passive-tree/${id}`
    case 'pob':
      return `/poe/pob/${id}`
    case 'planner':
      return `/poe/planner/${id}`
    default:
      return `/poe/planner/${id}`
  }
}
export const getTreePath = (profile: string, id: number) => `/poe/poe-tree/${profile}/${id}`
export const getAssetsPath = (path: string) => {
  const hash = hashes[path] ? `?${hashes[path]}` : ''
  if (typeof process === 'undefined') {
    return `${assets_path}/game/${path}${hash}`
  } else {
    return process.env.PUBLIC_URL + `/game/${path}${hash}`
  }
}

export const getIconPath = (path: string) => `https://assets-ng.maxroll.gg/poe/icons/${path}.webp`
export const getApiPath = (action: string) => `https://planners.maxroll.gg/${action}`
